import * as ToggleGroup from '@radix-ui/react-toggle-group'
import { styled } from 'styled-components'
import { useTranslation } from 'react-i18next'

import {
  TransactionType,
  TransactionValue,
  useBuySellStore,
} from '@/reducers/transactionReducer'
import { track } from '@/utils/analytics'

const Toggle = styled(ToggleGroup.Root)`
  display: inline-flex;
  gap: 17px;
`

const toggleFocusClass =
  'focus:outline-none focus:bg-neutral-200 dark:focus:bg-slate-600 border-b-transparent p-[2px] data-toggled:border-b-clementine dark:data-toggled:border-b-sun border-b-2'

export const BuySellSwitcher = ({ visibility }: { visibility: boolean }) => {
  const { t } = useTranslation()
  const transactionType = useBuySellStore.use.transactionType()
  const setTab = useBuySellStore.use.setTransactionType()
  return (
    <div>
      <Toggle
        className="text-base leading-tight"
        style={{ visibility: visibility ? 'hidden' : 'visible' }}
        type="single"
        value={transactionType}
        aria-label="Text alignment"
        onValueChange={(val: TransactionValue) => {
          if (val && val !== transactionType) {
            track('buy_sell_toggled', {
              to: val,
              from: transactionType,
            })
            setTab(val)
          }
        }}
        data-testid="select-transaction-switcher"
      >
        <ToggleGroup.ToggleGroupItem
          className={toggleFocusClass}
          value={TransactionType.BUY}
          aria-label="Buy"
          data-testid="btn-sell-switcher-buy-option"
        >
          {t('buySellSwitcher.buy')}
        </ToggleGroup.ToggleGroupItem>
        <ToggleGroup.ToggleGroupItem
          value={TransactionType.SELL}
          aria-label="Sell"
          className={toggleFocusClass}
          data-testid="btn-sell-switcher-sell-option"
        >
          {t('buySellSwitcher.sell')}
        </ToggleGroup.ToggleGroupItem>
      </Toggle>
    </div>
  )
}

/*
 * Code Improvement Suggestions:
 *
 * 1. The component could benefit from TypeScript prop interface definition for better type safety
 * 2. Consider extracting the style constants to a separate file for reusability
 * 3. The toggle focus class could be moved to a styled component or utility class
 * 4. The component could include a loading state for better UX during state changes
 * 5. Consider adding a disabled state for scenarios where switching might not be allowed
 */
